export default __webpack_public_path__ + "static/media/oscer-pres-urinary-frequency.7556ad7e.svg";